import React from "react";

const DashboardCard = ({ icon, value, label, color }) => (
  <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center space-x-4 min-h-[96px]">
    <div className={`p-3 rounded-xl ${color}`}>{icon}</div>
    <div>
      <p className="text-2xl font-semibold text-slate-900">{value}</p>
      <p className="text-sm font-medium text-slate-500">{label}</p>
    </div>
  </div>
);

export default DashboardCard;
